<script setup>
import { ref, watch } from "vue";
import WrForm from "./WrForm.vue";
import WrCrossIcon from "../atoms/icons/WrCrossIcon.vue";
const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false,
    required: true,
  },
  prefilledContent: {
    required: false,
  },
});

const emit = defineEmits(["close"]);
const visible = ref(props.isOpen);

const isSuccess = ref(false);
const formSubmitSuccessFully = () => {
  isSuccess.value = true;
  props.prefilledContent = [];
};
const onBackToForm = () => {
  isSuccess.value = false;
};

watch(
  () => props.isOpen,
  (newVal) => {
    visible.value = newVal;
  }
);

watch(visible, (newVal) => {
  if (!newVal) {
    emit("close");
  }
});

const handleClose = () => {
  if (isSuccess.value) {
    isSuccess.value = false;
  }
  visible.value = false;
};
</script>

<template>
  <div class="card flex justify-center z-30">
    <Dialog
      @hide="handleClose"
      v-model:visible="visible"
      :modal="true"
      :dismissableMask="true"
      closeOnEscape
      closable
      unstyled
      class="w-[90vw] md:w-[70vw] rounded-xl"
      :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
      :pt="{
        root: {
          class:
            'relative dark:bg-[linear-gradient(92.4deg,_rgba(53,9,91)_6.22%,rgba(63,0,119)_93.78%)] rounded-xl',
        },
        headerActions: {
          class: 'hidden',
        },
        mask: {
          class: 'backdrop-blur-sm',
        },
        content: { class: 'max-h-[90vh] overflow-y-auto' },
      }"
      role="dialog"
      aria-modal="true"
      aria-labelledby="dialog-title"
      aria-describedby="dialog-desc"
    >
      <template #header>
        <div class="absolute -top-3 -right-3 z-40">
          <button
            @click="handleClose"
            aria-label="Close dialog"
            class="focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500"
          >
            <WrCrossIcon
              class="text-white p-1 bg-red-500 rounded-full border-2"
            />
          </button>
        </div>
      </template>
      <div class="rounded-xl overflow-hidden">
        <h2 id="dialog-title" class="sr-only">Contact Form Dialog</h2>
        <p id="dialog-desc" class="sr-only">
          Fill out the form or review submission status in this modal dialog.
        </p>
        <WrThankYou
          v-if="isSuccess"
          @back-to-form="onBackToForm"
          :layoutChange="true"
          role="status"
          aria-live="polite"
        />
        <WrForm
          v-else
          :layoutChange="true"
          :prefilledContent="props.prefilledContent"
          @formsubmitted="formSubmitSuccessFully"
        />
      </div>
    </Dialog>
  </div>
</template>
<style type="css" scoped>
button:focus,
input:focus,
textarea:focus {
  outline: 2px solid #16a286;
  outline-offset: 2px;
}
</style>
